import { CDN_URL } from './index'

export default [
  {
    icon: `${CDN_URL}/logo_bzlt.png`,
    name: '爆装雷霆',
    url: '//pop.ad.w2you.cn/Planlist/ad?id=5de5d7a97638c329707caca2',
    appkey: '100003478'
  }
]